import { createPortal } from 'react-dom';

export default function HandoutModal({ handout, title, onClose }) {
  const handleCopy = () => {
    navigator.clipboard.writeText(handout).catch(() => {});
  };
  const handlePrint = () => {
    const w = window.open("", "_blank");
    w.document.write(`<!DOCTYPE html><html><head><title>${title} — Patient Handout</title>
      <style>body{font-family:Georgia,serif;max-width:700px;margin:40px auto;color:#111;line-height:1.7}
      h1{font-size:22px;margin-bottom:4px}h2{font-size:16px;margin-top:24px;margin-bottom:6px}
      ul{padding-left:20px}p{margin:6px 0}strong{font-weight:700}
      .footer{margin-top:40px;font-size:11px;color:#666;border-top:1px solid #ccc;padding-top:10px}</style>
      </head><body>
      <h1>${title}</h1>
      <p style="font-size:13px;color:#555">Patient Handout — Generated ${new Date().toLocaleDateString()}</p>
      ${handout.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>").replace(/\n\n/g, "</p><p>").replace(/\n- /g, "</p><ul><li>").replace(/\n/g, "<br>")}
      <div class="footer">This handout is for informational purposes only. Always follow your doctor's specific instructions.</div>
      </body></html>`);
    w.document.close();
    w.print();
  };

  const renderHandout = (text) => {
    return text.split("\n").map((line, i) => {
      if (line.startsWith("**") && line.endsWith("**")) {
        return <div key={i} style={{ fontFamily: "'Playfair Display', serif", fontSize: 14, fontWeight: 700, color: "#c7d2fe", marginTop: 16, marginBottom: 4 }}>{line.replace(/\*\*/g, "")}</div>;
      }
      if (line.startsWith("- ")) {
        return <div key={i} style={{ paddingLeft: 16, color: "rgba(255,255,255,0.75)", fontSize: 13, lineHeight: 1.6 }}>• {line.slice(2)}</div>;
      }
      if (line.trim() === "") return <div key={i} style={{ height: 4 }} />;
      return <div key={i} style={{ color: "rgba(255,255,255,0.75)", fontSize: 13, lineHeight: 1.6 }}>{line}</div>;
    });
  };

  return createPortal(
    <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.75)", backdropFilter: "blur(8px)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 300, padding: 20 }}>
      <div style={{ background: "#0f1923", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 20, width: "100%", maxWidth: 620, maxHeight: "85vh", display: "flex", flexDirection: "column" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "24px 28px 16px", borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
          <div>
            <div style={{ fontFamily: "'Playfair Display', serif", fontSize: 18, fontWeight: 600, color: "#f0ede8" }}>Patient Handout</div>
            <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", marginTop: 2 }}>{title}</div>
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button onClick={handleCopy} style={{ background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.12)", color: "rgba(255,255,255,0.7)", borderRadius: 8, padding: "7px 16px", cursor: "pointer", fontSize: 12 }}>Copy</button>
            <button onClick={handlePrint} style={{ background: "rgba(99,102,241,0.3)", border: "1px solid rgba(99,102,241,0.5)", color: "#c7d2fe", borderRadius: 8, padding: "7px 16px", cursor: "pointer", fontSize: 12 }}>Print</button>
            <button onClick={onClose} style={{ background: "none", border: "none", color: "rgba(255,255,255,0.4)", cursor: "pointer", fontSize: 22, lineHeight: 1, paddingLeft: 8 }}>×</button>
          </div>
        </div>
        <div style={{ overflowY: "auto", padding: "20px 28px 28px" }}>
          {renderHandout(handout)}
        </div>
      </div>
    </div>,
    document.body
  );
}
